var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormMessage',{attrs:{"text":_vm.text,"color":"bg-red-600"}})
}
var staticRenderFns = []

export { render, staticRenderFns }